var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconExit(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Icon_Logout",
    "data-name": "Icon / Logout",
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "#fff",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "login-black-18dp"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    width: 24,
    height: 24,
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Shape",
    d: "M18,18H10V16h8V2H10V0h8a2,2,0,0,1,2,2V16A2,2,0,0,1,18,18ZM5,14H5L0,9,5,4,6.4,5.4,3.8,8H14v2H3.8l2.6,2.6L5,14Z",
    transform: "translate(2 3)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconExit);
export default __webpack_public_path__ + "static/media/icon-exit.ad4d901759e9fc3a6c87e41ea6cf6a9e.svg";
export { ForwardRef as ReactComponent };